import React from 'react';

function Section({ section }) {
  return (
    <div className='d-flex justify-content-center container'>
      <div
        className='my-5 d-flex justify-content-center'
        style={{
          width: '95%',
          height: 'auto',
          borderRadius: '30px',
          position: 'relative',
          overflow: 'hidden',
          boxShadow:
            'rgba(255, 120, 3, 0.4) 5px 5px 5px -5px, rgba(255, 120, 3, 0.3) 10px 10px 10px 10px, rgba(255, 120, 3, 0.2) 15px 15px, rgba(255, 120, 3, 0.1) 20px 20px, rgba(255, 120, 3, 0.05) 25px 25px',
        }}
      >
        <img
          src={section.image}
          alt=''
          style={{
            width: 'auto',
            height: 'auto',
            maxWidth: '90%',
            padding: '20px',
          }}
          loading="lazy"
        />
      </div>
    </div>
  );
}

export default Section;
